module.exports = __webpack_public_path__ + "img/gallery-icon-09.a62dd40d.png";